const STORAGE_KEY = "skinagent_recent_views";
const MAX_ITEMS = 10;

export interface RecentView {
  slug: string;
  title: string;
  nature?: string;
  viewedAt: number;
}

export function addRecentView(slug: string, title: string, nature?: string) {
  if (typeof window === "undefined") return;
  try {
    const items = getRecentViews();
    const filtered = items.filter((v) => v.slug !== slug);
    filtered.unshift({ slug, title, nature, viewedAt: Date.now() });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered.slice(0, MAX_ITEMS)));
  } catch {}
}

export function getRecentViews(): RecentView[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}
